// import { createTheme } from "@mui/material/styles";

// export const getGoldDesignTokens = (mode) => ({
//   palette: {
//     mode,
//     primary: {
//       main: "#D4AF37",
//       light: "#F5D76E",
//       dark: "#B8860B",
//       contrastText: mode === "dark" ? "#000" : "#fff",
//     },
//     background: {
//       default: mode === "dark" ? "#0D0D0D" : "#F5F5F5",
//       paper: mode === "dark" ? "#1A1A1A" : "#FFFFFF",
//     },
//     text: {
//       primary: mode === "dark" ? "#FFFFFF" : "#0D0D0D",
//       secondary: mode === "dark" ? "rgba(255, 255, 255, 0.7)" : "rgba(0, 0, 0, 0.7)",
//     },
//     divider: "rgba(212, 175, 55, 0.2)",
//     mint: {
//       main: mode === "dark" ? "#1A2E29" : "#FFFFFF",
//       contrastText: mode === "dark" ? "#E0E0E0" : "#000000",
//     },
//   },
//   typography: {
//     fontFamily: "'Outfit', sans-serif",
//     h1: { fontWeight: 700 },
//     h2: { fontWeight: 700 },
//     h3: { fontWeight: 600 },
//     h4: { fontWeight: 600 },
//     button: {
//       textTransform: "none",
//       fontWeight: 600,
//     },
//   },
//   shape: {
//     borderRadius: 8,
//   },
//   components: {
//     MuiCssBaseline: {
//       styleOverrides: {
//         body: {
//           scrollbarColor: mode === "dark" ? "#D4AF37 #0D0D0D" : "#D4AF37 #F5F5F5",
//           "&::-webkit-scrollbar, & *::-webkit-scrollbar": {
//             width: "8px",
//           },
//           "&::-webkit-scrollbar-track, & *::-webkit-scrollbar-track": {
//             backgroundColor: mode === "dark" ? "#0D0D0D" : "#F5F5F5",
//           },
//           "&::-webkit-scrollbar-thumb, & *::-webkit-scrollbar-thumb": {
//             borderRadius: "8px",
//             backgroundColor: "#444",
//             border: `2px solid ${mode === "dark" ? "#0D0D0D" : "#F5F5F5"}`,
//           },
//           "&::-webkit-scrollbar-thumb:hover, & *::-webkit-scrollbar-thumb:hover": {
//             backgroundColor: "#D4AF37",
//           },
//         },
//       },
//     },
//     MuiButton: {
//       styleOverrides: {
//         root: {
//           borderRadius: 8,
//           padding: "8px 20px",
//         },
//         containedPrimary: {
//           background: "linear-gradient(45deg, #D4AF37 30%, #F5D76E 90%)",
//           color: "#000",
//           boxShadow: "0 3px 15px rgba(212, 175, 55, 0.3)",
//           "&:hover": {
//             background: "linear-gradient(45deg, #B8860B 30%, #D4AF37 90%)",
//             boxShadow: "0 5px 20px rgba(212, 175, 55, 0.4)",
//           },
//         },
//       },
//     },
//     MuiPaper: {
//       styleOverrides: {
//         root: {
//           backgroundImage: "none",
//           ...(mode === "dark" && {
//             border: "1px solid rgba(212, 175, 55, 0.1)",
//           }),
//         },
//       },
//     },
//     MuiTextField: {
//       styleOverrides: {
//         root: {
//           "& .MuiOutlinedInput-root": {
//             "&:hover .MuiOutlinedInput-notchedOutline": {
//               borderColor: "#D4AF37",
//             },
//             "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
//               borderColor: "#D4AF37",
//             },
//           },
//         },
//       },
//     },
//   },
// });

// export const createGoldTheme = (mode) => createTheme(getGoldDesignTokens(mode));

import { createTheme } from "@mui/material/styles";

export const getGoldDesignTokens = (mode) => ({
  palette: {
    mode,
    primary: {
      main: "#D4AF37", // Premium Gold
      light: "#F5D76E",
      dark: "#B8860B",
      contrastText: mode === "dark" ? "#FFFFFF" : "#0D0D0D",
    },
    secondary: {
      main: mode === "dark" ? "#FFFFFF" : "#0D0D0D",
      contrastText: mode === "dark" ? "#FFFFFF" : "#0D0D0D",
    },
    background: {
      default: mode === "dark" ? "#0D0D0D" : "#F5F7FA",
      paper: mode === "dark" ? "#1A1A1A" : "#FFFFFF",
    },
    text: {
      primary: mode === "dark" ? "#FFFFFF" : "#0D0D0D",
      secondary: mode === "dark" ? "#B3B3B3" : "#666666",
    },
    divider: "rgba(212, 175, 55, 0.2)",
    mint: {
      main: mode === "dark" ? "#1a1717ff" : "#FFFFFF",
      contrastText: mode === "dark" ? "#E0E0E0" : "#000000",
    },
  },
  typography: {
    fontFamily: "'Outfit', sans-serif",
    h1: { fontWeight: 800, letterSpacing: "-0.02em" },
    h2: { fontWeight: 800, letterSpacing: "-0.01em" },
    h3: { fontWeight: 700 },
    h4: { fontWeight: 700 },
    h5: { fontWeight: 600 },
    h6: { fontWeight: 600 },
    button: {
      textTransform: "none",
      fontWeight: 700,
    },
  },
  shape: {
    borderRadius: 12,
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          msOverflowStyle: "none", // IE and Edge
          scrollbarWidth: "none", // Firefox
          "&::-webkit-scrollbar, & *::-webkit-scrollbar": {
            display: "none", // Chrome, Safari and Opera
            width: 0,
            height: 0,
          },
          "&::-webkit-scrollbar-track, & *::-webkit-scrollbar-track": {
            backgroundColor: "transparent",
          },
          "&::-webkit-scrollbar-thumb, & *::-webkit-scrollbar-thumb": {
            display: "none",
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 50, // Pill shape from reference
          padding: "10px 28px",
          fontSize: "1rem",
          transition: "all 0.3s ease",
        },
        containedPrimary: {
          background: "linear-gradient(45deg, #D4AF37 30%, #F5D76E 90%)",
          color: "#0D0D0D",
          boxShadow: "0 4px 15px rgba(212, 175, 55, 0.3)",
          "&:hover": {
            background: "linear-gradient(45deg, #F5D76E 30%, #D4AF37 90%)",
            boxShadow: "0 6px 20px rgba(212, 175, 55, 0.5)",
            transform: "translateY(-2px)",
          },
        },
        outlinedPrimary: {
          borderColor: "#D4AF37",
          color: "#D4AF37",
          "&:hover": {
            borderColor: "#B8860B",
            backgroundColor: "rgba(212, 175, 55, 0.05)",
            transform: "translateY(-2px)",
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 20,
          backgroundImage: "none",
          border:
            mode === "dark"
              ? "1px solid rgba(212, 175, 55, 0.1)"
              : "1px solid rgba(0, 0, 0, 0.05)",
          boxShadow:
            mode === "dark"
              ? "0 10px 30px rgba(0,0,0,0.5)"
              : "0 10px 30px rgba(0,0,0,0.05)",
          transition: "all 0.3s ease",
          "&:hover": {
            borderColor: "#D4AF37",
            transform: "translateY(-5px)",
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: "none",
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          "& .MuiOutlinedInput-root": {
            borderRadius: 12,
            "&:hover fieldset": {
              borderColor: "#D4AF37",
            },
            "&.Mui-focused fieldset": {
              borderColor: "#D4AF37",
            },
          },
        },
      },
    },
  },
});

export const createGoldTheme = (mode) => createTheme(getGoldDesignTokens(mode));
